import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICarouselHomeText } from '../carousel/carousel-home/carousel-home.component';

@Component({
  selector: 'app-astrology-card',
  templateUrl: './astrology-card.component.html',
  styleUrls: ['./astrology-card.component.scss', './predict-card.scss']
})
export class AstrologyCardComponent implements OnInit {

  @Input() exploreAstro: string;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  gotoAstrologer(): void{
    this.router.navigate(['astrology']);
  }
}
